import { render, staticRenderFns } from "./addFankui.vue?vue&type=template&id=3656f390&scoped=true&"
import script from "./addFankui.vue?vue&type=script&lang=js&"
export * from "./addFankui.vue?vue&type=script&lang=js&"
import style0 from "./addFankui.vue?vue&type=style&index=0&id=3656f390&scoped=true&lang=css&"
import style1 from "./addFankui.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3656f390",
  null
  
)

export default component.exports